import React from 'react'
import styled from 'styled-components'
import {CardTreeInfo, Paragraph} from 'common/components'
import {useSelector} from 'lib/redux'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledSectionTree = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default function DropboxUploadInfo() {
  const {tree} = useSelector('user')!

  return (
    <StyledContainer>
      <StyledSectionTree>
        <Paragraph fontSize="m" fontWeight="bold" color="gray_5">
          Fototree Info
        </Paragraph>
        <CardTreeInfo url={tree.url} name={tree.name} description={tree.bio} />
      </StyledSectionTree>
    </StyledContainer>
  )
}
